module.exports = __webpack_public_path__ + "img/pay-2.ff14e0e5.png";